<template>
  <div class="articles__title">Articles</div>
  <div class="articles__container">
    <div class="articles__create">
      <div class="articles__secondary-title">
        {{ $vueTranslate('admin.articles.add_btn') }}
      </div>
      <Article
        :mode="MODES.CREATE"
        @[EMITTERS.ARTICLE_CREATED_EMITTER]="videoResourceArticleCreated"
      />
    </div>
    <div class="articles__index">
      <div class="articles__secondary-title">
        {{ $vueTranslate('admin.articles.created_btn') }}
      </div>
      <div v-if="!loading" ref="guideList" class="documents__list">
        <Article
          v-for="video_resource of video_resources"
          :key="video_resource.article_id"
          :video_resource="video_resource"
          :mode="MODES.SHOW"
          :theme="theme"
          @[EMITTERS.ARTICLE_DELETED_EMITTER]="articleDeleted"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { remove } from 'lodash'

import Article from './Article'
import {
  THEMES,
  VIDEO_RESOURCES_MODES as MODES,
} from '../../../shared/utils/view_options'
import ArticlesApiService from '../services/articlesApi.service'
import { EMITTERS } from '../../../shared/utils/emitters'

export default {
  name: 'ArticlesComponent',
  components: {
    Article,
  },
  props: {
    readOnlyMode: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: THEMES.LIGHT,
    },
  },
  data() {
    return {
      MODES,
      EMITTERS,
      video_resources: [],
      loading: true,
    }
  },
  created() {
    this.fetchVideoResourceArticles()
  },
  methods: {
    fetchVideoResourceArticles() {
      ArticlesApiService.getAllVideoResourceArticles(this.optional_params)
        .then((response) => {
          this.video_resources = response.data.video_resources_articles
        })
        .catch(console.error)
        .finally(() => {
          this.loading = false
        })
    },
    videoResourceArticleCreated() {
      this.fetchVideoResourceArticles()
    },
    articleDeleted(video_resource) {
      remove(
        this.video_resources,
        (element) => element.id === video_resource.id
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.articles__container {
  background-color: #ffffff;
  width: 95%;
  min-height: 610px;
}

.articles__title {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  color: #323232;
  margin-bottom: 16px;
}

.articles__secondary-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #5c5c5c;
  padding-bottom: 10px;
}

.articles__create,
.articles__index {
  padding: 16px;
}

.articles__create {
  border-bottom: 1px solid #eaedee;
}
</style>
